export var MuiPickersArrowSwitcher = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                flex: 1,
                gap: theme.spacing(0.5),
                '& > .MuiTypography-root': {
                    flex: 1,
                },
                '& .MuiPickersCalendarHeader-labelContainer': {
                    overflow: 'visible',
                    justifyContent: 'center',
                    height: '100%',
                },
                '& .MuiPickersCalendarHeader-labelContainer button': {
                    flex: 1,
                },
                // All buttons in the header will have basic text color
                '& button': {
                    color: theme.palette.text.primary,
                },
            });
        },
    },
};
